// The login screen inside the iPhone app (a web screen) means the web
// view's cookie is gone, when the session check said so. The app is told
// ({type: "signed-out"}, spec §6): it mints a fresh web code once, then
// shows its own sign-in. Only for a 401 or a sign-out here: the login
// screen also shows when the check could not reach the server (offline, a
// 5xx), and that is no sign-out; nothing is posted then. The form stays
// usable meanwhile. A no-op in any browser.

import { useEffect, useRef } from "react";

import { useAuth } from "@/stores/auth";

import { isEmbedded, postToNative, tellsNativeSignedOut } from "./embedded";

export function useNativeSignedOut(): void {
  const reason = useAuth((s) => s.signedOut);
  // Once per showing: StrictMode runs the effect twice.
  const told = useRef(false);
  useEffect(() => {
    if (told.current || !isEmbedded() || !tellsNativeSignedOut(reason)) return;
    told.current = true;
    postToNative({ type: "signed-out" });
  }, [reason]);
}
